import React from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Spekit Case Study | Canny';
const Description = 'Learn how Spekit uses Canny to make data-backed product decisions.';
const Image = 'https://canny-assets.io/images/5bd4908e2b2863da603777ec113526e2.png';
const SpekitUrl = 'https://canny.io/case-studies/spekit';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${SpekitUrl}#webpage`,
    url: SpekitUrl,
    name: 'Case Study: Spekit × Canny',
    description: 'Why Spekit relies on Canny to make data-backed product decisions.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${SpekitUrl}#article`,
    genre: 'Case Study',
    headline: 'Why Spekit relies on Canny to make data-backed product decisions',
    description:
      'Spekit was drowning in user feedback across Salesforce, Intercom, and email, making prioritization impossible. By consolidating feedback into Canny—reviewing over 650 posts, marking 95 as Complete, integrating with Jira and Slack, and utilizing changelog capabilities—Spekit transformed scattered input into strategic insights and eliminated internal friction.',
    inLanguage: 'en',
    url: SpekitUrl,
    mainEntityOfPage: { '@id': `${SpekitUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Spekit', url: 'https://spekit.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Spekit', item: SpekitUrl },
  ]),
]);

const SpekitLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: SpekitUrl },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}>
      <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
    </Helmet>
  );
};

export default SpekitLandingHelmet;
